import { useGetApiProjectsByProjectIdDataSharesQuery } from '@/model/dataShare/api.generated';
import type { DataShareResponse } from '@/model/dataShare/dto.generated';
import { skipToken } from '@reduxjs/toolkit/query';

const NO_SHARES: DataShareResponse[] = [];

export function useProjectDataShares(projectId: string | undefined): {
  shares: DataShareResponse[];
  isLoading: boolean;
} {
  const { data, isLoading } = useGetApiProjectsByProjectIdDataSharesQuery(
    projectId ? { projectId } : skipToken,
  );
  return { shares: data?.['data'] ?? NO_SHARES, isLoading };
}
